import { useMatches } from "@tanstack/react-router";
import {
    digestList,
    discussionsReadRoute,
    editUserProfile,
    eventsRoute,
    favoritesIndexRoute,
    favoritesPrivateRoute,
    favoritesPublicRoute,
    friendList,
    liveRoute,
    loginRoute,
    messagesRoute,
    resourceCategoryRoute,
    resourcePostRoute,
    rssCategoryRoute,
    rssList,
    socialPost,
    socialProfile,
    socialRoute,
    trendingRoute,
    userProfile,
    vendorList,
} from "app/router";

export const usePageDetector = () => {
    const matches = useMatches();
    const matchedIds = new Set(matches.map(({ route: { id } }) => id));

    // /favorites/private shows the private nav; all other favorites routes show social nav
    const isOnFavoritesPrivate = matchedIds.has(favoritesPrivateRoute.id);

    const isSocialPage =
        !isOnFavoritesPrivate &&
        (matchedIds.has(resourceCategoryRoute.id) ||
            matchedIds.has(vendorList.id) ||
            matchedIds.has(rssList.id) ||
            matchedIds.has(rssCategoryRoute.id) ||
            matchedIds.has(digestList.id) ||
            matchedIds.has(resourcePostRoute.id) ||
            matchedIds.has(socialProfile.id) ||
            matchedIds.has(socialRoute.id) ||
            matchedIds.has(socialPost.id) ||
            matchedIds.has(userProfile.id) ||
            matchedIds.has(editUserProfile.id) ||
            matchedIds.has(liveRoute.id) ||
            matchedIds.has(friendList.id) ||
            matchedIds.has(eventsRoute.id) ||
            matchedIds.has(messagesRoute.id) ||
            matchedIds.has(favoritesIndexRoute.id) ||
            matchedIds.has(favoritesPublicRoute.id) ||
            matchedIds.has(trendingRoute.id));

    const isDiscussionPage = useMatches().some(
        (match) => match.route.id === discussionsReadRoute.id,
    );

    const isLoginPage = useMatches().some((match) => match.route.id === loginRoute.id);

    const isPrivatePage = !isSocialPage && !isLoginPage;

    return { isSocialPage, isPrivatePage, isDiscussionPage, isLoginPage };
};
